/**
 * Linguagem de cores do mapa de acompanhamento.
 *
 * As famílias saem da referência que o cliente enviou: azul para deslocamento, âmbar para quem está
 * aguardando e verde para etapa concluída. A referência agrupa nove status em três cores; a Ana
 * pediu cor própria por status, então cada um tem o seu tom dentro da família — a leitura de relance
 * continua sendo a que o designer deles desenhou, e nenhum status fica indistinguível do vizinho.
 *
 * Âmbar em todo "aguardando" não é escolha estética: é a mesma partição que o relatório de tempo de
 * espera usa para separar caminhão parado de caminhão andando.
 */

/** Percurso e ponto ainda não iniciado. É o cinza que a Ana pediu para o deslocamento. */
export const CINZA_PERCURSO = "#8A94A6";

export const CORES_DO_STATUS = {
  LOADING_PENDING: CINZA_PERCURSO,
  UNLOADING_PENDING: CINZA_PERCURSO,

  HEADING_TO_PICKUP: "#2563EB",
  IN_TRANSIT: "#1D4ED8",

  WAITING_LOADING: "#F59E0B",
  WAITING_DOCUMENTATION: "#D97706",
  WAITING_UNLOADING: "#B45309",

  LOADING_COMPLETED: "#16A34A",
  UNLOADING_COMPLETED: "#15803D",
};

/** Coleta verde, entrega vermelha. É o arranjo da referência. */
export const COR_DA_COLETA = "#0D8344";
export const COR_DA_ENTREGA = "#E5322A";

/**
 * O caminhão é o único marcador escuro do mapa, e é de propósito: era o laranja #FF3100 da marca,
 * vizinho demais do #E5322A da entrega, e num frete de destino próximo o operador via dois pinos
 * vermelhos iguais sem saber qual era o motorista. O laranja não sumiu — virou o halo que pulsa em
 * volta, que é o que diz que aquele ponto está vivo.
 */
export const COR_DO_MOTORISTA = "#111827";
export const COR_DO_PULSO_DO_MOTORISTA = "#FF3100";

export const AZUL_DO_TRAJETO = "#2563EB";

/** O trecho que não existe. Mesmo âmbar escuro do "aguardando descarregamento", de propósito. */
export const COR_DA_LACUNA = "#B45309";

export function corDoStatus(status) {
  return CORES_DO_STATUS[String(status || "").toUpperCase()] || CINZA_PERCURSO;
}
